import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HTMLFlipBook from "react-pageflip";

const images = [
    require("../assets/images/catalogue/page_1.jpg"),
    require("../assets/images/catalogue/page_2.jpg"),
    require("../assets/images/catalogue/page_3.jpg"),
    require("../assets/images/catalogue/page_4.jpg"),
    require("../assets/images/catalogue/page_5.jpg"),
    require("../assets/images/catalogue/page_6.jpg"),
    require("../assets/images/catalogue/page_7.jpg"),
    require("../assets/images/catalogue/page_8.jpg"),
    require("../assets/images/catalogue/page_9.jpg"),
    require("../assets/images/catalogue/page_10.jpg"),
    require("../assets/images/catalogue/page_11.jpg"),
    require("../assets/images/catalogue/page_12.jpg"),
    require("../assets/images/catalogue/page_13.jpg"),
    require("../assets/images/catalogue/page_14.jpg"),
    require("../assets/images/catalogue/page_15.jpg"),
    require("../assets/images/catalogue/page_16.jpg"),
    require("../assets/images/catalogue/page_17.jpg"),
];

const Catalogue = ({ navBarHeight }) => {
    const { t } = useTranslation();
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    // useEffect(() => {
    //     // Prevent scrolling when touching the FlipBook container
    //     const preventScroll = (e) => {
    //         e.preventDefault();
    //     };

    //     const flipBookContainer = document.querySelector(".flip-book-container");
    //     if (flipBookContainer) {
    //         flipBookContainer.addEventListener("touchmove", preventScroll, { passive: false });
    //         flipBookContainer.addEventListener("wheel", preventScroll, { passive: false });
    //     }

    //     return () => {
    //         if (flipBookContainer) {
    //             flipBookContainer.removeEventListener("touchmove", preventScroll);
    //             flipBookContainer.removeEventListener("wheel", preventScroll);
    //         }
    //     };
    // }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getBookDimensions = () => {
        const aspectRatio = 0.707;
        if (windowSize.width < 768) {
            const width = windowSize.width * 0.9;
            const height = width / aspectRatio;
            return {
                width,
                height: Math.min(height, windowSize.height),
            };
        } else if (windowSize.width >= 768 && windowSize.width < 1024) {
            const height = windowSize.height;
            const width = Math.min(height * aspectRatio * 0.54, windowSize.width * 0.45); // Double the width for two pages
            return {
                width: width,
                height: width / aspectRatio,
            };
        } else {
            const height = windowSize.height;
            const width = height * aspectRatio * 0.9; // Double the width for two pages
            return {
                width: Math.min(width, windowSize.width * 0.9) * 0.8,
                height: height * 0.7,
            };
        }
    };

    const dimensions = getBookDimensions();
    return (
        <div
            className="flex items-center justify-center bg-[#16a34a1a] overflow-hidden"
            style={{ height: `calc(100vh - ${navBarHeight}px)` }}
        >
            {/* <div className="flip-book-container flex flex-col md:p-4 bg-white shadow-lg rounded-lg"> */}
            <div className="flex flex-col md:p-4 bg-white shadow-lg rounded-lg">
                <HTMLFlipBook
                    width={dimensions.width}
                    height={dimensions.height}
                    showCover={false}
                    className="shadow-lg"
                    size="stretch"
                    minWidth={dimensions.width}
                    maxWidth={dimensions.width * 2}
                    minHeight={dimensions.height}
                    maxHeight={dimensions.height * 2}
                    drawShadow={true}
                    flippingTime={600}
                    useMouseEvents={true}
                    startPage={0}
                    autoSize={true}
                    maxShadowOpacity={0.5}
                    mobileScrollSupport={true}
                    clickEventForward={true}
                    usePortrait={windowSize.width < 768}
                    startZIndex={0}
                    renderOnlyPageLengthChange={false}
                    style={{
                        border: "1px solid #ddd",
                        // touchAction: "none",
                    }}
                >
                    {images.map((img, index) => (
                        <div
                            key={index}
                            className="w-full h-full flex items-center justify-center bg-gray-100 border border-gray-300"
                        >
                            <img
                                src={img}
                                alt={`Page ${index + 1}`}
                                className="w-full h-full object-contain"
                            />
                        </div>
                    ))}
                </HTMLFlipBook>
                <p className="mt-2 md:pt-4 text-base italic text-center text-[#555]">
                    {t("swipeNclick")}
                </p>
            </div>
        </div>
    );
};

export default Catalogue;
